import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Accountings/Document";
import GridConfig from "./GridConfig";
import SelectAsync from 'react-select/async';

export default class CashTransactionReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            configName: 'cashtransaction_report',
            systemModuleId: 8,
            moduleAccessStatus: 1,
            cashDeskId: this.getDefaultGuid(),
            menuId: 59
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    refreshData(e) {
        if (!this.isNull(e))
            e.preventDefault();
        this.httpPost("api/v1/report/cashtransaction", {
            cashDeskId: this.state.cashDeskId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "date", caption: "تاریخ", show: true },
                { field: "documentNumber", caption: "سند", show: true },
                { field: "description", caption: "شرح", show: true },
                { field: "bed", caption: "بدهکار", show: true },
                { field: "bes", caption: "بستانکار", show: true },
                { field: "remain", caption: "مانده", show: true },
                { field: "tashkis", caption: "تشخیص", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'documentNumber' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showDocument(props.data.documentId)}>{props.data.documentNumber}</a> } });
            if (f.field == 'description' && f.show) t.push({flex:3, field: f.field, headerName: f.caption });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            if (f.field == 'tashkis' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="container">
            <div className="card card-bordered card-stretch">
                <div className="card-inner position-relative card-tools-toggle">
                    <div className="row">
                        <div className="col-sm-9">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <SelectAsync
                                            //defaultValue={item.cashDeskId != this.defaultGuid() ? [{ value: item.cashDeskId, label: item.cashDeskName }] : null}
                                            isMulti={false}
                                            placeholder="انتخاب صندوق"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadCashdesksOptions(inputValue, callback, 0)}
                                            onChange={e => this.state.cashDeskId = e.value}
                                        />
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-sm-3 text-left">
                            <ul className="nk-block-tools g-3">
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('گردش حساب صندوق ها')}><span>چاپ</span></a>
                                </li>
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('گردش حساب صندوق ها')}><span>PDF</span></a>
                                </li>
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('گردش حساب صندوق ها')}><span>اکسل</span></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                {this.renderAgGrid({
                    columnDefs: this.getColumns()
                })}
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}